<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  {{ data.content }}
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false" cdkFocusInitial>Cancel</button>
  <button mat-button [mat-dialog-close]="true" color="warn">Ok</button>
</div>
